import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const EmojiHeartIcon = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M21 12a9 9 0 1 0-8.012 8.946M9 10h.01M15 10h.01"></path>
        <path d="M9.5 15a3.6 3.6 0 0 0 2.774.99m6.72 5.51l2.518-2.58a1.74 1.74 0 0 0 .004-2.413a1.627 1.627 0 0 0-2.346-.005l-.168.172l-.168-.172a1.627 1.627 0 0 0-2.346-.004a1.74 1.74 0 0 0-.004 2.412z"></path>
      </g>
    </svg>
  );
};
export default EmojiHeartIcon;
